import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ContactButton from '../../About/ContactButton';
import ChatWithUsDiscordButton from '../../About/ChatWithUsDiscordButton';
import Button from '@mui/material/Button';
import AddCircle from '@mui/icons-material/AddCircle';

export default function HostingMore({ openBlogWizard, blogNo }) {
  return (
    <div className="px-4">
      <Typography gutterBottom variant="h5" className="pt-5">
        <Box fontWeight="fontWeightBold">Looking for more options?</Box>
      </Typography>
      <Typography gutterBottom variant="body1">
        Need help with your blog or have a suggestion for us? We&apos;d love to
        hear from you! Whether you want to delete a blog, use your own domain,
        or just have a question or feature request, we&apos;re here to assist.
        Let us know how we can make your experience even better.
      </Typography>
      <ContactButton isOutlined />
      <ChatWithUsDiscordButton isOutlined />
      <Typography gutterBottom variant="h5" className="pt-5">
        <Box fontWeight="fontWeightBold">
          How about {blogNo === '1' ? 'a second' : 'another'} blog?
        </Box>
      </Typography>
      <Typography variant="body1">
        Ready to branch out and expand your travel blogging empire? With
        TravelFeed, you can easily manage multiple blogs, all from the same
        dashboard. Whether you want to create a dedicated blog for your
        adventures in Thailand, share your foodie finds, or keep documenting
        your general travel experiences, it&apos;s all possible. And the best
        part? You can choose which blog(s) to feature each post in, so you can
        really tailor your content to your audience. Start exploring the
        possibilities and take your travel blogging to new heights!
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        className="mt-2"
        onClick={openBlogWizard}
      >
        <AddCircle />
        <span className="pl-2">Create new Blog</span>
      </Button>
    </div>
  );
}
